import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../../data/site';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section aria-labelledby="faq-title" className="border-t border-line" data-id="element-82" data-mp="2a2pkpxkbob79">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-24 md:px-8 md:py-28 lg:grid-cols-12" data-id="element-83" data-mp="1v5ytwcops7t9">
        <div className="lg:col-span-4" data-id="element-84" data-mp="2062z36k69g46">
          <h2 id="faq-title" className="font-serif text-4xl font-medium leading-tight text-forest md:text-5xl" data-id="element-85" data-mp="2074l262q7n0o">
            Questions fréquentes
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-86" data-mp="1r4d8u4210n7z">
            Une autre question ? Posez-la directement dans votre demande de devis.
          </p>
        </div>

        <ul className="border-t border-line lg:col-span-8" data-id="element-87" data-mp="3liwe2edyd4tp">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <li key={faq.question} className="border-b border-line" data-id="element-88" data-mp="2jevnzdr82tkp" data-mpi={index}>
                <h3 data-id="element-89" data-mp="2x5r2p6oek4w7">
                  <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpenIndex(open ? null : index)} className="flex w-full items-center justify-between gap-6 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-forest" data-id="element-90" data-mp="2x6a85nwv90tc">
                    <span className="text-lg font-medium text-ink" data-id="element-91" data-mp="2efskvyusyxfd">{faq.question}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-forest transition-transform duration-200 ${open ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-92" data-mp="29gfy1e3xlqcs" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-93" data-mp="3kv3bw6jqccyi">
                  {open && <motion.div id={panelId} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduce ? undefined : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-94" data-mp="3svhn4g7eh1ma">
                      <p className="max-w-2xl pb-6 leading-relaxed text-ink-muted" data-id="element-95" data-mp="39678z6nayoqa">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}